<section
    class="ce-banner"
    *ngIf="showBanner"
    [ngClass]="[themeClass, bannerType === 'service-tools' ? 'ce-banner--service-tools' : '']"
    aria-label="Notification banner"
>
    <div class="ce-banner__content fx-row fx-layout-align-start-center fx-layout-gap-8">
        <mat-icon class="ce-banner__icon" aria-hidden="true">warning_amber</mat-icon>

        <!-- Subscription expiry banner -->
        <span class="ce-banner__text" *ngIf="bannerType === 'subscription'">
            Your <strong>{{ licenseName | licenseName }}</strong> subscription for
            {{ organizationName }}
            <strong *ngIf="daysUntilSubscriptionExpiry === 0">ends at the end of today</strong>
            <strong *ngIf="daysUntilSubscriptionExpiry === 1">ends at the end of tomorrow</strong>
            <strong *ngIf="daysUntilSubscriptionExpiry > 1">ends in {{ daysUntilSubscriptionExpiry }} days</strong>.
            Contact Kempower sales to renew it.
        </span>

        <!-- Service Tools certification warning banner (before restriction date) -->
        <span class="ce-banner__text" *ngIf="bannerType === 'service-tools-warning'">
            It seems you <strong>don't have the right certification for Service Tools access</strong>. Please get
            certified by end of March 2026, otherwise the access will be removed. Read the
            <a class="ce-banner__link" (click)="openCertificationDialog()" (keydown.enter)="openCertificationDialog()"
                ><strong>instructions on how to get certified here</strong></a
            >.
        </span>

        <!-- Service Tools certification removal banner (after restriction date) -->
        <span class="ce-banner__text" *ngIf="bannerType === 'service-tools'">
            Your <strong>Service Tools access</strong> has been removed since you
            <strong>don't have the required certification</strong> or it expired. You can read the
            <a class="ce-banner__link" (click)="openCertificationDialog()" (keydown.enter)="openCertificationDialog()"
                ><strong>instructions on how to get certified here</strong></a
            >.
        </span>

        <!-- Service Tools certification expiring banner (after restriction date, within 30 days) -->
        <span class="ce-banner__text" *ngIf="bannerType === 'service-tools-expiring'">
            Your <strong>Service Tools access </strong>
            <strong *ngIf="daysUntilCertificationExpiry === 0">ends at the end of today</strong>
            <strong *ngIf="daysUntilCertificationExpiry === 1">ends in {{ daysUntilCertificationExpiry }} day</strong>
            <strong *ngIf="daysUntilCertificationExpiry > 1">ends in {{ daysUntilCertificationExpiry }} days</strong>
            because your certification is expiring. You can read the
            <a class="ce-banner__link" (click)="openCertificationDialog()" (keydown.enter)="openCertificationDialog()"
                ><strong>instructions on how to get certified here</strong></a
            >.
        </span>

        <button
            class="ce-banner__close"
            mat-icon-button
            type="button"
            aria-label="Dismiss banner"
            (click)="onDismissBanner()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>
</section>
